Object.defineProperty(exports,"__esModule",{value:true});exports.useOpenURL=useOpenURL;var _reactNative=require("react-native");
var _is=require("../is");






function useOpenURL(){
function openURL(url){
if(
_is.isPlatformIos||
_is.isPlatformAndroid||
_is.isPlatformMacos||
_is.isPlatformWeb)
{

_reactNative.Linking.openURL(url).catch(function(err){return console.error('An error occurred',err);});
}else{

}
}
return openURL;
}
//# sourceMappingURL=linking.js.map